import { customBarRenderItem } from '@/components/patient-stats/graphs/mapping-chart-options/render-functions'
import {
  buildSeriesDataForMultiPoint,
  convertToMappingChartDataPoint,
  divideDataSpreadingAcrossOverTwoDays,
  groupByDayForMCDataPoint,
} from './utils'
import moment from 'moment-timezone'
import { CHART_DATE_FORMAT } from '@/components/patient-stats/constants'
import { removeAbbr } from '@/utils/time'

export function buildWalkingDurationSeries({ timezone, yAxis, walkingDuration, options }) {
  const withOffset = walkingDuration.map(convertToMappingChartDataPoint(timezone))
  const sparedWithOffset = divideDataSpreadingAcrossOverTwoDays(withOffset, timezone)
  const dataByDay = groupByDayForMCDataPoint(sparedWithOffset)
  const seriesData = buildSeriesDataForMultiPoint(dataByDay, yAxis)

  return {
    ...options,
    type: 'custom',
    renderItem: customBarRenderItem,
    data: seriesData,
    itemStyle: {
      color: '#FFE93A',
    },
    tooltip: {
      formatter: params => {
        const data = params.value[params.value.length - 1]
        const fromLabel = moment(data.rawStartTimestamp)
          .tz(timezone)
          .format(removeAbbr(timezone, CHART_DATE_FORMAT.TIME_ABBR))
        const toLabel = moment(data.rawEndTimestamp)
          .tz(timezone)
          .format(removeAbbr(timezone, CHART_DATE_FORMAT.TIME_ABBR))
        return `${fromLabel} - ${toLabel}`
      },
    },
  }
}
